import React, { useState } from "react";
import { useGetTenantLoginActivityMutation } from "../../../features/admin/adminActivity/adminActivityApi";
import { useFetchVendorsQuery } from "../../../features/admin/vendor/vendorApi";
import toast from "react-hot-toast";

const TenantLoginActivity = () => {
  const token = sessionStorage.getItem("access_token");
  
  const [selectedTenant, setSelectedTenant] = useState("");
  const [logs, setLogs] = useState([]);
  
  const { data: vendorsData, isLoading: vendorsLoading } = useFetchVendorsQuery(token);
  const [getLogs, { isLoading: fetchingLogs }] = useGetTenantLoginActivityMutation();

  const tenants = vendorsData?.body || [];

  const fetchLogs = async (tenantId) => {
    setSelectedTenant(tenantId);
    if (!tenantId) {
      setLogs([]);
      return;
    }
    try {
      const res = await getLogs({ token, tenant_id: tenantId, limit: 100 }).unwrap();
      if (res?.success) {
        setLogs(res.body || []);
      } else {
        toast.error(res?.message || "Failed to fetch logs");
      }
    } catch (e) {
      toast.error("Failed to fetch logs");
    }
  };

  return (
    <div style={{ padding: "28px 32px", minHeight: "100vh", background: "#f1f5f9", fontFamily: "'Inter', sans-serif" }}>
      <div style={{ marginBottom: "28px" }}>
        <h1 style={{ fontSize: "24px", fontWeight: 800, color: "#0f172a", margin: "0 0 4px" }}>Tenant Login Activity</h1>
        <p style={{ fontSize: "14px", color: "#64748b", margin: 0 }}>View panel login attempts across all tenants</p>
      </div>

      <div style={{ background: "#fff", borderRadius: "16px", padding: "24px", boxShadow: "0 2px 16px rgba(15,23,42,0.07)", marginBottom: "24px" }}>
        <label style={{ display: "block", fontSize: "13px", fontWeight: 600, color: "#374151", marginBottom: "8px" }}>
          Select Tenant
        </label>
        <select 
          style={{ width: "300px", padding: "10px 14px", borderRadius: "10px", border: "1.5px solid #e2e8f0", background: "#f8fafc", outline: "none" }}
          value={selectedTenant}
          onChange={(e) => fetchLogs(e.target.value)}
        >
          <option value="">-- Choose a tenant --</option>
          {tenants.map(t => (
            <option key={t.tenant_id} value={t.tenant_id}>{t.name} (ID: {t.tenant_id})</option>
          ))}
        </select>
      </div>

      {selectedTenant && (
        <div style={{ background: "#fff", borderRadius: "16px", boxShadow: "0 2px 16px rgba(15,23,42,0.07)", overflow: "hidden" }}>
          <div style={{ padding: "18px 28px", borderBottom: "1px solid #f1f5f9", background: "#fafbfc", display: "flex", gap: "10px", alignItems: "center" }}>
            <span style={{ fontSize: "20px" }}>📋</span>
            <span style={{ fontSize: "16px", fontWeight: 700, color: "#1e293b", flex: 1 }}>Login Activity Logs</span>
          </div>

          <div style={{ overflowX: "auto" }}>
            {fetchingLogs ? (
              <div style={{ padding: "60px 20px", textAlign: "center", color: "#94a3b8" }}>Loading logs...</div>
            ) : logs.length === 0 ? (
              <div style={{ padding: "60px 20px", textAlign: "center", color: "#94a3b8" }}>No login records found for this tenant.</div>
            ) : (
              <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13.5px", textAlign: "left" }}>
                <thead>
                  <tr style={{ background: "#f8fafc", borderBottom: "2px solid #e2e8f0" }}>
                    <th style={{ padding: "12px 16px", fontWeight: 700, color: "#475569", textTransform: "uppercase", fontSize: "12px" }}>User</th>
                    <th style={{ padding: "12px 16px", fontWeight: 700, color: "#475569", textTransform: "uppercase", fontSize: "12px" }}>Date & Time</th>
                    <th style={{ padding: "12px 16px", fontWeight: 700, color: "#475569", textTransform: "uppercase", fontSize: "12px" }}>Status</th>
                    <th style={{ padding: "12px 16px", fontWeight: 700, color: "#475569", textTransform: "uppercase", fontSize: "12px" }}>IP Address</th>
                    <th style={{ padding: "12px 16px", fontWeight: 700, color: "#475569", textTransform: "uppercase", fontSize: "12px" }}>Device / Browser</th>
                  </tr>
                </thead>
                <tbody>
                  {logs.map((log) => (
                    <tr key={log.id} style={{ borderBottom: "1px solid #f1f5f9", background: log.status === 2 ? "#fff5f5" : "#fff" }}>
                      <td style={{ padding: "14px 16px" }}>
                        <div style={{ fontWeight: 700, color: "#1e293b", fontSize: "14px" }}>{log.user_name || "Unknown"}</div>
                        <div style={{ fontSize: "11px", color: "#94a3b8" }}>{log.user_email || `ID: ${log.user_id}`}</div>
                      </td>
                      <td style={{ padding: "14px 16px", color: "#1e293b", fontWeight: 500 }}>{log.created_at_formatted}</td>
                      <td style={{ padding: "14px 16px" }}>
                        <span style={{ 
                          padding: "3px 12px", borderRadius: "20px", fontSize: "12px", fontWeight: 700,
                          background: log.status == 1 ? "#f0fdf4" : "#fef2f2",
                          color: log.status == 1 ? "#16a34a" : "#dc2626",
                          border: `1.5px solid ${log.status == 1 ? "#bbf7d0" : "#fecaca"}`
                        }}>
                          {log.status == 1 ? "✓ Success" : "✗ Failed"}
                        </span>
                      </td>
                      <td style={{ padding: "14px 16px", fontFamily: "monospace", color: "#475569", fontSize: "12px" }}>{log.ip_address || "—"}</td>
                      <td style={{ padding: "14px 16px", color: "#64748b", fontSize: "11.5px", maxWidth: "240px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={log.user_agent || ""}>
                        {log.user_agent ? log.user_agent.slice(0, 50) + (log.user_agent.length > 50 ? "…" : "") : "—"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default TenantLoginActivity;
